<template>
    <div v-if="refundModal" class="refund-modal">
        <div class="refund-modal__container">
            <h2 class="refund-modal__title">Возврат</h2>
            <form v-if="!message" @submit.prevent="submit">
                <div class="form-group">
                    <input v-model="amount" required type="number" class="form-control" placeholder="Сумма возврата">
                </div>
                <div class="form-group">
                    <textarea v-model="reason" required rows="3" class="form-control" placeholder="Причина возврата"/>
                </div>
                <button :disabled="disabled" class="btn btn-primary" type="submit"> Отправить </button>
            </form>
            <h4 v-else :style="{ color: messageColor }" > {{ message }} </h4>
            <div class="refund-modal__close" @click="refundModalToggle(false)">
                 <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div @click="refundModalToggle(false)" class="refund-modal__overlay"></div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            amount: null,
            reason: null,
            disabled: false,
            message: null,
            success: false
        }
    },
    computed: {
        ...mapState({
            refundModal: 'refundModal',
            refundModalCurrentId: 'refundModalCurrentId'
        }),
        messageColor() {
            return this.success ? 'green' : 'red'
        }
    },
    methods: {
        ...mapActions({
            refundModalToggle: 'refundModalToggle'
        }),
        async submit() {
            try {
                this.disabled = true;
                const url = '/admin/ajax/payment/refund';
                const res = await axios.post(url, {
                    refund_amount: this.amount,
                    refund_reason: this.reason,
                    payment_id: this.refundModalCurrentId
                });
                if (res.data.success) {
                    this.message = "Возврат успешно проведен";
                    setTimeout(() => {
                        location.reload()
                    }, 500);
                } else {
                    this.message = res.data.message;
                    setTimeout(() => {
                        location.reload()
                    }, 500);
                }
            }
            catch(err) {
                console.log(err);
                this.message = "К сожалению произошла ошибка";

            }
        }
    }
}
</script>
